import React from 'react';
import '../App.css';

const Background = ({ children }) => {
  return (
    <div className='relative z-0 bg-gradient-to-r from-gray-800 via-gray-900 to-black  overflow-hidden'>
      <ul className="circles absolute inset-0 flex justify-center items-center space-x-4">
      
<div class="absolute inset-0 -z-10 h-full w-full bg-white ,linear-grabg-[linear-gradient(to_right,#f0f0f0_1px,transparent_1px)dient(to_bottom,#f0f0f0_1px,transparent_1px)] bg-[size:6rem_4rem]"><div class="absolute bottom-0 left-0 right-0 top-0 bg-[radial-gradient(circle_800px_at_100%_200px,#d5c5ff,transparent)]"></div></div>

      </ul>
      <div className='relative z-10'>{children}</div>
    </div>
  );
};

export default Background;
